import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Media from './media/Media';
import Schedule from './schedule/Schedule';
import Room from './room/Room';
import Company from './company/Company';
import UserManagement from './usermanagement/UserManagement';
import DataHome from './data/DataHome'
import Browser from './browser/Browser';
import Display from './display/Display';
import Login from './login/Login';
import SchoolList from './schoollist/SchoolList';
import Translation from './translation/Translation';
import SchoolQuota from './schoolquota/SchoolQuota';
import Group from './group/Group';
import Students from './students/Students';
import Report from './report/Report';
import Occupation from './occupation/Occupation';

/* Components */
import SideNav from './sidenav/SideNav';
import TopNav from './topnav/TopNav';

/* Other pages */
import NotFound from './otherpages/NotFound';

/* Player */
import AudioPlayer from './common/player/AudioPlayer';

/* Header Animation */
import HeaderAnimation from './common/particles/Particles';

import './app.css';

const ScrollToTopPage = () => {
	window.scrollTo(0, 0);
	return null;
};

class App extends Component {
	constructor(props) {
		super(props);
		if (this.props.userAuthenticated && this.props.router.location.pathname === '/login') {
			if (this.props.userProfile.user && this.props.userProfile.user.role === 'admin') {
				this.props.history.push('/schoollist');
			} else {
				this.props.history.push('/schoolquota');
			}
		}
	}

	render() {
		const { userProfile } = this.props;
		const userRole = (userProfile.user) ? userProfile.user.role : null;

		const PrivateRoute = ({ component: Component, isAuthenticated, typeAccount, ...rest }) => (
			<Route
				{...rest}

				render={props => (isAuthenticated ?
					(typeAccount && !typeAccount.includes(userRole)) ? <Redirect to="/schoolquota" /> : <Component {...props} />
					:
					(<Redirect to="/login" />)
				)}
			/>
		);

		const pathName = this.props.router.location.pathname;

		const classMainContent = (pathName !== '/login') ? 'mainContent mainContentDefault' : 'mainContent';
		const headerAnimate = (window.innerWidth > 768) ? <HeaderAnimation /> : "";

		return (
			<div className="App">
				{
					(this.props.router.location.pathname !== '/login') ?
						<div>
							<SideNav />
							<TopNav />
							<div className="backdropHeader"><div className="content">{headerAnimate}</div></div>
							<AudioPlayer />
						</div>
						:
						""
				}

				<Switch>
					<Route component={ScrollToTopPage} />
				</Switch>

				<div className={classMainContent}>
					<Switch>
						<Route path="/login" component={Login} />

						{/* <PrivateRoute exact path="/" component={Schedule} isAuthenticated={this.props.userAuthenticated} /> */}
						<Route exact path="/" render={() => <Redirect to="/login" />} />
						<PrivateRoute exact path="/room" component={Room} isAuthenticated={this.props.userAuthenticated} typeAccount="admin" />
						<PrivateRoute exact path="/usermanagement" component={UserManagement} isAuthenticated={this.props.userAuthenticated} typeAccount="admin" />
						<PrivateRoute exact path="/data" component={DataHome} isAuthenticated={this.props.userAuthenticated} typeAccount="admin" />
						<PrivateRoute exact path="/browser" component={Browser} isAuthenticated={this.props.userAuthenticated} typeAccount="admin" />
						<PrivateRoute exact path="/display" component={Display} isAuthenticated={this.props.userAuthenticated} typeAccount="admin" />
						<PrivateRoute exact path="/media" component={Media} isAuthenticated={this.props.userAuthenticated} typeAccount="admin" />
						<PrivateRoute exact path="/company" component={Company} isAuthenticated={this.props.userAuthenticated} typeAccount="admin" />
						<PrivateRoute exact path="/schoollist" component={SchoolList} isAuthenticated={this.props.userAuthenticated} typeAccount="admin" />
						<PrivateRoute exact path="/translation" component={Translation} isAuthenticated={this.props.userAuthenticated} typeAccount="admin" />
						<PrivateRoute exact path="/schoolquota" component={SchoolQuota} isAuthenticated={this.props.userAuthenticated} typeAccount="admin,user" />
						<PrivateRoute exact path="/class" component={Group} isAuthenticated={this.props.userAuthenticated} typeAccount="admin,user" />
						<PrivateRoute exact path="/occupation" component={Occupation} isAuthenticated={this.props.userAuthenticated} typeAccount="admin" />
						<PrivateRoute exact path="/students/:id" component={Students} isAuthenticated={this.props.userAuthenticated} typeAccount="admin,user" />
						<PrivateRoute exact path="/report/:id" component={Report} isAuthenticated={this.props.userAuthenticated} typeAccount="admin,user" />
						<Route path="*" exact component={NotFound} />
					</Switch>
				</div>
			</div>
		);
	}
}


const mapStateToProps = state => ({
	router: state.router,
	userAuthenticated: state.user.userAuthenticated,
	userProfile: state.user.userProfile
});

export default withRouter(connect(mapStateToProps)(App));
